const TONES = {
  neutral: 'bg-[rgba(11,11,15,.05)] text-[var(--ink-2)]',
  brand:   'bg-[rgba(37,99,235,.08)] text-[#2563EB]',
  amber:   'bg-[rgba(245,158,11,.10)] text-[#A86A06]',
  emerald: 'bg-[rgba(16,185,129,.10)] text-[#0F8C66]',
  red:     'bg-[rgba(239,68,68,.08)] text-[#C13030]',
  purple:  'bg-[rgba(147,51,234,.08)] text-[#7C3AED]',
}

export default function Pill({ children, tone = 'neutral', className = '', ...rest }) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-medium ${TONES[tone]} ${className}`}
      {...rest}
    >
      {children}
    </span>
  )
}
